import { customerListCollection } from '@finance-hub/domain/customers/blocs/collections/customer-list-collection';
import { FinanceHubCustomerRow } from '@finance-hub/domain/customers/blocs/types/customer-list';

/**
 * Inserts freshly fetched customer rows, skipping chat ids already present so
 * the unbounded response only adds the customers the initial one missed.
 *
 * @param rows - Transformed rows from either customer list response
 */
export const insertCustomerListRows = (rows: FinanceHubCustomerRow[]): void => {
  const newRows = rows.filter((row) => !customerListCollection.get(row.chatId));
  if (newRows.length > 0) {
    customerListCollection.insert(newRows);
  }
};
